import type { Session } from "@/Modules/Models/Domain/ClinicalHistory";
import type { SessionApi } from "@/Modules/Models/Api/ClinicalHistory";
import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";

const SessionTransformer: TransformerExtended<Session, SessionApi> = {
  ...DefaultTransformerGenerator<Session, SessionApi>(),

  toDomain(input: SessionApi) {
    return camel<SessionApi, Session>(input);
  },
};

export type SessionTransformerType = TransformerExtended<Session, SessionApi>;

export default SessionTransformer;
